
function trackDeskConversion(conversionType, amount) {
  let conversionDone = JSON.parse(localStorage.getItem("conversionDone"));
  if (!conversionDone) {

    console.log("trackDeskConversion", conversionType, amount)
    trackdesk("boloforms-signature", "conversion", {
      "conversionType": conversionType,
      amount: {
        value: amount
      },
      currency: "USD"

    });
    localStorage.setItem("conversionDone", true);
  }
}

export { trackDeskConversion };
